import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI } from '../Interface';

const FolderTemplateFields = ({ viewField }) => {
  const { errors, values } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Sablon neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="defaultTemplate"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett sablon" />}
          disabled={viewField}
        />
      </div>
    </div>
  );
};

export default FolderTemplateFields;
